const $ = window.$ = window.jQuery = require('jquery');

require('bootstrap');

require('./common/nestable');
require('./common/select');
require('./common/tooltip');
require('./common/locale-tabs');

require('./components/components');
require('./components/Builder/Index');
require('./common/datepicker');
require('./common/review');
require('./common/filter-date');
require('./common/filter-select');
